import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const IncreasingDecreasing = () => (
  <QPhototModuleSubtopic
    title="Increasing and decreasing"
    videos={[
      "https://www.youtube.com/embed/t8mUzXzcV8E",
      "https://www.youtube.com/embed/QrqhH7OFlLc",
      "https://www.youtube.com/embed/O0CH9Vjk7mU",
      "https://www.youtube.com/embed/25xv61AXUFA"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_5.jpeg"
        },
        {
            image:"/cal_6.jpeg"
        },
        {
            image:"/cal_7.jpeg"
        },
        {
            image:"/cal_8.jpeg"
        },
        {
            image:"/cal_9.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default IncreasingDecreasing;
